// store/slices/loaderSlice.ts
import { createSlice } from '@reduxjs/toolkit'

interface LoaderState {
  showLoader: boolean
  pendingRequests: number
}

const initialState: LoaderState = {
  showLoader: false,
  pendingRequests: 0
}

export const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoader: (state) => {
      state.showLoader = true
      state.pendingRequests += 1
    },
    hideLoader: (state) => {
      state.pendingRequests -= 1
      state.showLoader = false;

      if(state.pendingRequests === 0) {
        return;
      }
      if (state.pendingRequests < 0) {
        state.showLoader = false
      }
    },
  }
})

export const { showLoader, hideLoader } = loaderSlice.actions
export default loaderSlice.reducer;